import { useQuery } from 'react-query'
import { fileService, FileQueryParams } from '@services/fileService'

export function usePdfFiles(params?: FileQueryParams) {
  return useQuery(['pdfFiles', params], () => fileService.getPdfs(params), {
    keepPreviousData: true,
  })
}





